import { Text as e } from "../Typography/Typography.js";
import "../Typography/index.js";
import { useGetRegisteredMenuItems as t } from "../ApplicationMenu/useGetRegisteredMenuItems.js";
import { DOWNLOAD_SUBMENU_ID as n } from "../ApplicationMenu/constants.js";
import "../ApplicationMenu/index.js";
import r from "./DownloadSelectButton.module.js";
import { c as i } from "react/compiler-runtime";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Button as s } from "@jetbrains/ring-ui-built/components/button/button";
import c from "@jetbrains/icons/download";
import l from "@jetbrains/icons/warning";
import u from "@jetbrains/ring-ui-built/components/dropdown-menu/dropdown-menu";
import d from "@jetbrains/ring-ui-built/components/icon/icon";
import { Type as f } from "@jetbrains/ring-ui-built/components/list/consts";
//#region src/components/DownloadSelectButton/DownloadSelectButton.tsx
var p = 10, m = {
	icon: c,
	inline: !1,
	title: "Download SARIF file",
	"aria-label": "Download SARIF file"
}, h = (e) => {
	let r = i(9), { onClick: o } = e, c = t(n);
	if (!c?.length) {
		let e;
		return r[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ a(s, {
			...m,
			loader: !0,
			"data-test": "download-sarif-file-button-loading"
		}), r[0] = e) : e = r[0], e;
	}
	let l;
	r[1] === c ? l = r[2] : (l = c.map(g), r[1] = c, r[2] = l);
	let d = l, f;
	r[3] === o ? f = r[4] : (f = /* @__PURE__ */ a(s, {
		...m,
		onClick: o,
		"data-test": "download-sarif-file-button"
	}), r[3] = o, r[4] = f);
	let p;
	r[5] === Symbol.for("react.memo_cache_sentinel") ? (p = {
		top: 4,
		activateFirstItem: !1,
		"data-test": "download-sarif-file-dropdown-popup"
	}, r[5] = p) : p = r[5];
	let h;
	return r[6] !== d || r[7] !== f ? (h = /* @__PURE__ */ a(u, {
		anchor: f,
		menuProps: p,
		data: d
	}), r[6] = d, r[7] = f, r[8] = h) : h = r[8], h;
};
function g(t) {
	let { key: n, label: i, description: s, onClick: c } = t;
	return {
		key: n,
		rgItemType: f.CUSTOM,
		onClick: c,
		template: /* @__PURE__ */ o("span", { children: [i, s && /* @__PURE__ */ o("div", {
			className: r.errorDescriptionContainer,
			children: [/* @__PURE__ */ a(d, {
				size: p,
				className: r.errorDescriptionIcon,
				glyph: l
			}), /* @__PURE__ */ a(e, {
				small: !0,
				className: r.errorDescription,
				children: s
			})]
		})] })
	};
}
//#endregion
export { h as DownloadSelectButton };
